import React from 'react';
import { Link } from 'react-router-dom';
import action from '../../assets/images/action.png';
import noRecord from '../../assets/images/cloud-cross.png';
import StatusTag from '../StatusTag';

const QuestionAnswers = ({ leads, archiveLead }) => {
	return (
		<div id='tab-2' className='tab-content current customizeHeights'>
			<div className='tableInfo groupListingTables'>
				<div className='listTables secondTab'>
        {leads && leads.length > 0 && (
					<ul className='individualRow tableHead'>
						<li className='groupHead'>Group Name</li>
						<li className='memberHead'>Member name</li>
						<li className='questionsHead'>Q1 & A1</li>
						<li className='questionsHead'>Q2 & A2</li>
						<li className='questionsHead'>Q3 & A3</li>
						<li className='statusHead'>Status</li>
						<li className='actionHead'>Action</li>
					</ul>
        )}
					{leads && leads.length < 1 && (
						<ul className='individualRow noRecordsWraper tableContent'>
              <li className='noRecord messageWrater'>
                <p>No Records found</p>
                <span className="noImageWraper">
                  <img src={noRecord} alt="" />
                </span>
              </li>
            </ul>
					)}
					{leads &&
						leads.map((lead, i) => {
							return (
								<ul className='individualRow tableContent tabQuestions' key={i}>
									<li className='groupContent'>
										<a
											rel='noreferrer'
											target='_blank'
											href={
												'https://www.facebook.com/groups/' + lead.group?.groupId
											}
										>
											{lead.group?.groupName}
										</a>
									</li>
									<li className='memberContent'>
										<Link to={'/member-details/' + lead._id}>
											{lead.fbuser?.firstName + ' ' + lead.fbuser?.lastName}
										</Link>
									</li>
									<li className='questionAnswerContent'>
										<span className='questionsSpan'>
											<span className='questionNumbering'>Q</span>
											<span className='questionContent'>{lead.question1}</span>
										</span>
										<span className='answerSpan'>
											<span className='answerNumbering'>A</span>
											<span className='answerContent'>{lead.answer1}</span>
										</span>
									</li>
									<li className='questionAnswerContent'>
										<span className='questionsSpan'>
											<span className='questionNumbering'>Q</span>
											<span className='questionContent'>{lead.question2}</span>
										</span>
										<span className='answerSpan'>
											<span className='answerNumbering'>A</span>
											<span className='answerContent'>{lead.answer2}</span>
										</span>
									</li>
									<li className='questionAnswerContent'>
										<span className='questionsSpan'>
											<span className='questionNumbering'>Q</span>
											<span className='questionContent'>{lead.question3}</span>
										</span>
										<span className='answerSpan'>
											<span className='answerNumbering'>A</span>
											<span className='answerContent'>{lead.answer3}</span>
										</span>
									</li>
									{/* <!-- Use pending or cancel classNamees in place of approved for different status --> */}
									<li className='statusContent'>
										{/*<span
											className={
												'status ' +
												(lead.status === 'Approved'
													? 'approved'
													: lead.status === 'Declined'
													? 'cancel'
													: lead.status === 'Removed'
													? 'pending'
													: '')
											}
										>
											{lead.status}
										</span>*/}
                    <StatusTag status={lead.status} />
									</li>
									<li
										className='actionContent'
										onClick={() => archiveLead(lead._id)}
									>
										<img alt='qaimage' src={action} className='actionImg' />
									</li>
								</ul>
							);
						})}{' '}
				</div>
			</div>
		</div>
	);
};

export default QuestionAnswers;
